import { useState } from "react";
import { Stack, IconButton } from "@mui/material";
import {
  GitHub as GithubIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon
} from "@mui/icons-material";

import { useStore, observer } from "../../service/mobx";
import { DiscordIcon } from "../Icon/Discord";

function Social() {
  const [icons] = useState([
    { Icon: DiscordIcon, href: "https://discord.gg/ZydhEJTd3R" },
    { Icon: GithubIcon, href: "https://github.com/Bytez-com/docs" },
    { Icon: TwitterIcon, href: "https://x.com/bytez" },
    { Icon: LinkedInIcon, href: "https://www.linkedin.com/company/bytez/" }
  ]);
  const { layout } = useStore();
  const render = layout.navOpen ? icons : [icons[0]];

  return (
    <Stack direction="row" spacing={1} width="100%" alignItems="center">
      {render.map(({ Icon, href, onClick }) => (
        <IconButton
          key={href}
          href={href}
          onClick={onClick}
          target={href ? "_blank" : undefined}
          sx={{
            height: 56,
            width: 56,
            borderRadius: "var(--shape-md-round)"
          }}
        >
          <Icon />
        </IconButton>
      ))}
    </Stack>
  );
}

export default observer(Social);
